import { Badge, Box, Button, Stack, Typography } from "@mui/material";
import * as React from "react";

import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { NotificationIcon } from "../../../components/ui-elements/svg-icons";
import { styled, useTheme } from "@mui/material/styles";
import useEcho from "../../../hooks/echo";
import { Howl } from "howler";
import Axios from "../../../utils/http-request";
import { NotificationDetails } from "./notification-details";
import { NotificationMessage } from "../../../interface/messages";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { apiGetNotification } from "../../../api/account";

export const NotificationContent = () => {
  const theme = useTheme();

  const intervalRef = React.useRef<number | null>(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const verified = useSelector((state: RootState) => state.content.verified);
  const [new_notification, setNew_notification] = React.useState(false);

  const [unreadMessages, setUnreadMessages] = React.useState(0);
  const [messages, setMessages] = React.useState([]);
  const [notifications, setNotifications] = React.useState<
    NotificationMessage[]
  >([]);
  const queryClient = useQueryClient();

  const echo = useEcho();
  const id = useSelector(
    (state: RootState) => state.content.account_profile_data
  ).id;
 

  // fetch notifications
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["notifications"],
    queryFn: async () => {
      const result = await apiGetNotification();
      if (result.status === "error" && "details" in result) {
        return [];
      }
      if (result?.status === 200) {
        if (Array.isArray(result.data)) {
          setNotifications(result.data);
        }
      }
      return result?.data || [];
    },
  });
  const open = Boolean(anchorEl);

  const sound = new Howl({
    src: ["/media/bell.mp3"],
  });

  const handleEchoCallback = () => {
    setUnreadMessages((prevUnread) => prevUnread + 1);
    queryClient.invalidateQueries({ queryKey: ["notifications"] });
    sound.play();
  };

  const handle_click = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setNew_notification(false);
  };
  const handle_close = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    // Here we are going to listen for real-time events.
    if (echo) {
     
      echo.private(`user.${id}`).listen("Notification", (event: any) => {
        if (event.account_id === id)
        setNotifications((prev) => [event, ...prev]);
        setNew_notification(true);
        handleEchoCallback();
      });
    }

    Axios.get("/chats/unread", {
      params: {
        // Add params object
        user_id: id,
      },
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then((res) => {
      setUnreadMessages(res.data.length);
      setMessages(res.data);
    });
  }, [id, unreadMessages, echo]);

  return (
    <>
      <Box
        sx={{
          borderRadius: "20px",
          width: "38px",
          height: "38px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          color: theme.palette.primary.main,
          mx: 3,
          cursor: "pointer",
        }}
        onClick={handle_click}
      >
        <Badge color="primary" variant={new_notification ? "dot" : "standard"}>
          <NotificationIcon />
        </Badge>
        <Typography
          sx={{
            fontWeight: 400,
            color: theme.palette.secondary.contrastText,
            fontSize: 12,
            letterSpacing: "-0.11px",
          }}
        >
          Notification
        </Typography>
      </Box>

      <NotificationDetails
        anchorEl={anchorEl}
        open={open}
        handle_close={handle_close}
        data={notifications}
      />
    </>
  );
};
